<template>
    <ActiveJobs></ActiveJobs>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const ActiveJobs = defineAsyncComponent(() =>
    import("../../components/DPAM_PunchSystem/ActiveJobs.vue")
);

export default {
    name: "DPAM_PUNCH_VIEW_ACTIVE", //The name you are in should not equal the name of the component you are importing.
    components: { ActiveJobs, AuthLayout },
};
</script>
